import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AddCollectionAccModalUI from './AddCollectionAccModalUI'

class AddCollectionAccModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form fields
      collectionAccHolderName: '',
      collectionAccHolderNameError: null,
      collectionAccBankName: '',
      collectionAccBankNameError: null,
      collectionAccNumber: '',
      collectionAccNumberError: null,
      ifscCode: '',
      ifscCodeError: null,
    }
  }

  render() {
    return (
      <AddCollectionAccModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        collectionAccHolderName={this.state.collectionAccHolderName}
        onCollectionAccHolderNameChange={(event) => this.setState({ collectionAccHolderName: event.target.value })}
        collectionAccHolderNameError={this.state.collectionAccHolderNameError}
        setCollectionAccHolderNameError={(error) => { this.setState({ collectionAccHolderNameError: error }) }}
        // collection account bank name field
        collectionAccBankName={this.state.collectionAccBankName}
        onCollectionAccBankNameChange={(event) => this.setState({ collectionAccBankName: event.target.value })}
        collectionAccBankNameError={this.state.collectionAccBankNameError}
        setCollectionAccBankNameError={(error) => { this.setState({ collectionAccBankNameError: error }) }}
        // collection account number field
        collectionAccNumber={this.state.collectionAccNumber}
        onCollectionAccNumberChange={(event) => this.setState({ collectionAccNumber: event.target.value })}
        collectionAccNumberError={this.state.collectionAccNumberError}
        setCollectionAccNumberError={(error) => { this.setState({ collectionAccNumberError: error }) }}
        // ifsc code field
        ifscCode={this.state.ifscCode}
        onIfscCodeChange={(event) => this.setState({ ifscCode: event.target.value })}
        ifscCodeError={this.state.ifscCodeError}
        setIfscCodeError={(error) => { this.setState({ ifscCodeError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/escrowAccounts/collectionAccount`,
      this.onSubmitCallback, {
        collectionAccHolderName: this.state.collectionAccHolderName,
        collectionAccBankName: this.state.collectionAccBankName,
        collectionAccNumber: this.state.collectionAccNumber,
        ifscCode: this.state.ifscCode,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(AddCollectionAccModalSF)